import mapKeys from 'lodash/mapKeys';
import snakeCase from 'lodash/snakeCase';

export const formatToSnakeCase = (obj: object | null | undefined) =>
  mapKeys(obj || {}, (_v, k) => snakeCase(k));
